import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Amavasya.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import axios from 'axios';
// import { useMemo } from 'react';
import city from '../../../city.json'



const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};


const extractDayMonth = (dateStr = "") => {
  if (!dateStr) return { day: "--", month: "--" };

  // Example: "January 28, 2025, Tuesday"
  const parts = dateStr.split(",");

  const day = parts[1]?.trim() || "--"; // Tuesday
  const month = parts[0]?.split(" ")[0] || "--"; // January

  return { day, month };
};


const Amavasya = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12hr');

  const [amavasyaList, setAmavasyaList] = useState([]);

 const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);
const [selectedSankasthi, setSelectedSankasthi] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };


  const amavasyaTooltipData = {
  "January Amavasya": "January Amavasya is considered sacred for performing Pitru Tarpan and honoring ancestors. It is a time for spiritual reflection and new beginnings.",
  "February Amavasya": "February Amavasya is an ideal day for meditation, cleansing rituals, and offering respects to departed souls.",
  "March Amavasya": "March Amavasya holds importance for seeking peace for ancestors and is often associated with rituals to reduce negative planetary effects.",
  "April Amavasya": "April Amavasya, falling in spring, is a spiritually potent day for new ventures, prayers, and offerings to the departed.",
  "May Amavasya": "May Amavasya is favorable for performing charity and feeding the needy, as well as performing Shraddha rituals.",
  "June Amavasya": "June Amavasya is observed with fasting and devotion, particularly in temples dedicated to Lord Shiva or the Divine Mother.",
  "July Amavasya": "July Amavasya is often observed as Ashadha Amavasya, especially significant in South India for Pitru Puja and spiritual baths in rivers.",
  "August Amavasya": "August Amavasya is considered auspicious for removing ancestral karma and is observed with fasting and prayers.",
  "September Amavasya": "September Amavasya falls near the Mahalaya fortnight, a crucial period for performing ancestral rites in Hindu tradition.",
  "October Amavasya": "October Amavasya, also known as Sarva Pitru Amavasya (if during Mahalaya), is dedicated entirely to forefathers and their blessings.",
  "November Amavasya": "November Amavasya is ideal for inward focus and spiritual practices, commonly observed with silence and simplicity.",
  "December Amavasya": "December Amavasya closes the lunar calendar year with prayers for peace, purification, and gratitude to ancestors."
};


  


useEffect(() => {
  const fetchAmavasyaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/amavasya?year=${year}&location=${encodeURIComponent(location)}`
      );
      

      // The response contains an object with `amavasyas` array
      if (response.data && response.data.amavasyas) {
        setAmavasyaList(response.data.amavasyas);
      } else {
        setAmavasyaList([]);
      }
    // const todayAmavasya = amavasyaList.find(item => item.date === todayISO);
 
    } catch (error) {
      console.error("Failed to fetch Amavasya data:", error);
      setAmavasyaList([]);
    }
  };

  fetchAmavasyaData();
}, [year, location]);


  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });


// const todayISO = currentDate.toISOString().split('T')[0];
// const todayAmavasya = useMemo(() => {
//   return amavasyaList.find(item => item.date === todayISO);
// }, [amavasyaList, todayISO]);


  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };



  return (
    <div className="Amavasya-container">
      <InnerNav />
      <div className="Amavasya-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendarr-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Amavasya Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
                <div>
                   {/* {todayAmavasya ? (
                      <div className="today-amavasya-highlight">
                        <h3>Today's Amavasya</h3>
                        <p><strong>{todayAmavasya.name}- {todayAmavasya.tithiName}</strong></p>
                        <p>{formatTime(todayAmavasya.tithiStart, timeFormat)} — {formatTime(todayAmavasya.tithiEnd, timeFormat)}</p>
                       
                      </div>
                    ):(
                      <p>no data available</p>
                    )} */}
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="A-controls">
                <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>

              </div>
            </div>
          </div>
{!selectedSankasthi ? (
            <div className="amavasya-list">
              {amavasyaList.length === 0 && <p>No Amavasya data available for selected year/location.</p>}
              {amavasyaList.map((item, idx) => (
                <div
  className="amavasya-item clickable"
  key={idx}
  onClick={() => setSelectedSankasthi(item)}
>

                  <img
                  src='https://static.toiimg.com/thumb/msid-110076502,width-400,resizemode-4/110076502.jpg'
                    alt="Amavasya"
                  />
                  <div className="amavasya-details">
                    <p className="amavasya-date">{item.date}</p>
                    {/* <div className="tooltip-wrapper">
                      <div className="amavasya-name">{item.name}</div>
                      <span className="tooltip-text">{amavasyaTooltipData[item.name] || "No info available"}</span>
                    </div> */}

{/* <div
  className="san-name clickable"
  onClick={() => setSelectedSankasthi(item)}
>
  {item.name}
</div> */}


<div className="amavasya-name">{item.name}</div>



                    <p className="amavasya-phase">{item.phase}</p>
                    <p className="amavasya-tithi">{item.tithiName}</p>
                  </div>
                  <div className="amavasya-timings">
                    <p>{item.lunarDetail}</p>
                    <p>{formatTime(item.tithiStart, timeFormat)}</p>
                    <p>{formatTime(item.tithiEnd, timeFormat)}</p>
                  </div>

                </div>
              ))}
            </div>
            ) : (
<div className="san-detail-view">
  <button className="back-btn" onClick={() => setSelectedSankasthi(null)}>
    ← Back
  </button>

  <h2>{selectedSankasthi.name}</h2>

  <img
    src="https://static.toiimg.com/thumb/msid-110076502,width-400,resizemode-4/110076502.jpg"
    alt={selectedSankasthi.name}
  />

  <div className="report-section">

    <div className="detail-grid">
      <div><strong>Date:</strong> {selectedSankasthi.date}</div>
      <div><strong>Phase:</strong> {selectedSankasthi.phase}</div>
      <div><strong>Tithi:</strong> {selectedSankasthi.tithiName}</div>
      <div><strong>Tithi Start:</strong> {formatTime(selectedSankasthi.tithiStart, timeFormat)}</div>
      <div><strong>Tithi End:</strong> {formatTime(selectedSankasthi.tithiEnd, timeFormat)}</div>
    </div>

    <p className="report-text">
      {amavasyaTooltipData[selectedSankasthi.name] ||
        "This Amavasya is spiritually significant and observed with fasting, prayer, and ancestral rituals."}
    </p>

    <h3 className="detail-heading">Rituals & Observance</h3>
    <ul className="detail-list">
      <li>Pitru Tarpan and Shraddha for ancestors</li>
      <li>Fasting or satvik food</li>
      <li>Charity and food donation</li>
      <li>Meditation and mantra chanting</li>
    </ul>

    <h3 className="detail-heading">Do & Don’t on Amavasya</h3>
    <div className="do-dont">
      <div>
        <h4>✔ Do</h4>
        <ul>
          <li>Wake up early</li>
          <li>Offer water to ancestors</li>
          <li>Maintain calmness</li>
        </ul>
      </div>
      <div>
        <h4>✖ Don’t</h4>
        <ul>
          <li>Avoid alcohol & non-veg</li>
          <li>Avoid new ventures</li>
          <li>Avoid arguments</li>
        </ul>
      </div>
    </div>

  </div>
</div>


)}


        </div>
        {/* Ekadashi Calendar JSX ends here */}

            <section className="amavasya-wrapper">
      <h1 className="amavasya-title">Amavasya Days / New Moon Days</h1>
      <div className="amavasya-texts">
        <p>
          Amavasya is new moon day in Hindu calendar. It is a significant day as many rituals are performed only on Amavasya Tithi. Amavasya falling on weekday Monday is known as <strong>Somvati Amavasya</strong> and Amavasya falling on weekday Saturday is known as <strong>Shani Amavasya</strong>.
        </p>

        <p>
          All Amavasya days are appropriate to perform <strong>Shraddha</strong> rituals to appease ancestors. Amavasya day is also an appropriate day to perform <strong>Kalasarpa Dosha puja</strong>.
        </p>

        <p>
          Amavasya is also spelled and pronounced as <strong>Amavasai</strong> or <strong>Amavas</strong>.
        </p>
      </div>
    </section>
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Amavasya;
